import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CardDetails = ({ movie }) => {
  const [isLoading, setIsLoading] = useState(true);
  // console.log(movie);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      {isLoading ? (
        <div className=''>
          <div className=''>
            <span className='w-full h-40 block bg-gray-200 '></span>
          </div>

          <div className='mt-2 w-full mb-8'>
            <ul className='mt-5 space-y-3'>
              <li className='w-full h-4 bg-gray-200 rounded-md '></li>
              <li className='w-full h-4 bg-gray-200 rounded-md '></li>
              <li className='w-full h-4 bg-gray-200 rounded-md '></li>
              <li className='w-full h-4 bg-gray-200 rounded-md'></li>
            </ul>
          </div>
        </div>
      ) : (
        <Link
          className=' flex flex-col group bg-white border shadow-sm rounded-xl overflow-hidden hover:shadow-lg transition  dark:shadow-slate-700/[.7]'
          to={`/movie/${movie.id}`}
        >
          <div className='relative pt-[90%] sm:pt-[60%] lg:pt-[150%] rounded-t-xl overflow-hidden'>
            <img
              className='w-full h-full absolute top-0 left-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-t-xl'
              src={`https://www.themoviedb.org/t/p/w220_and_h330_face/${movie.poster_path}`}
              alt='Image Description'
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
              }}
            />
          </div>
          <div className='p-4 md:p-5'>
            <h3 className='text-lg font-bold  text-gray-800 '>{movie.title}</h3>
            <div className='flex gap-10'>
              <p className='mt-1 text-gray-400 dark:text-gray-400'>
                {movie?.release_date}
              </p>
              <p className='mt-1 text-gray-400 dark:text-gray-400'>
                {movie.vote_average} <i className='fa-regular fa-star'></i>
              </p>
            </div>
          </div>
        </Link>
      )}
    </>
  );
};

export default CardDetails;
